import React, { useRef } from 'react';
import { Container, Content, Bar, Progress } from './ScrollProgressBar.styles';
import { motion, useScroll, useTransform } from 'framer-motion';

export interface ScrollProgressBarProps {
  children: React.ReactNode;
  show?: boolean;
}

const ScrollProgressBar: React.FC<ScrollProgressBarProps> = ({
  children,
  show = false,
  ...rest
}) => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const { scrollYProgress } = useScroll({
    offset: ['start end', 'end'],
    target: contentRef,
  });
  const percentProgress = useTransform(scrollYProgress, [0, 1], ['0%', '100%']);
  const percentOpacity = useTransform(
    scrollYProgress,
    [0, 0.02, 0.98, 1],
    ['0%', '100%', '100%', '0%']
  );

  return show ? (
    <Container {...rest}>
      <Content ref={contentRef}>{children}</Content>
      <Bar
        as={motion.div}
        style={{
          opacity: percentOpacity,
        }}
      >
        <Progress
          as={motion.div}
          style={{
            translateX: percentProgress,
          }}
        />
      </Bar>
    </Container>
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};

export default ScrollProgressBar;
